module.exports = __webpack_public_path__ + "media/sq_header_zada.ac96f064.mp4";